export interface BackgroundDesaturationConfig {
  enabled: boolean;
  strength: number; // 0.0 = full color, 1.0 = grayscale
  affectsParallax: boolean;
  affectsGround: boolean;
  affectsProps: boolean;
}

export interface VisualSettings {
  backgroundDesaturation: BackgroundDesaturationConfig;
}

export const DEFAULT_VISUAL_SETTINGS: VisualSettings = {
  backgroundDesaturation: {
    enabled: true,
    strength: 0.45, // 45% desaturation (sweet spot)
    affectsParallax: true,
    affectsGround: true,
    affectsProps: true,
  }
};
